import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleTonnageList } from "../../../Api/api";


// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const tonnageListAsync=createAsyncThunk(
   "tonnage/list",
   async ({ done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await handleTonnageList();
         if (response.statusCode === 200) {
            done && done();
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const tonnageMasterSlice = createSlice({
   name: "companyMaster",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(tonnageListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(tonnageListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(tonnageListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default tonnageMasterSlice.reducer;